import { Component } from '@angular/core';

import { DocMeta } from "@template-ui/decorators";
import { UiLibraryModule } from "@template-ui/template-ui.module";
import { OverlayIcons } from "@template-ui/types";


@DocMeta({
  hide: true
})
@Component({
    selector: 'ui-overlay-icon-sample, ez-overlay-icon-sample',
    imports: [UiLibraryModule],
    templateUrl: './overlay-icon-sample.html',
    styleUrl: './overlay-icon-sample.scss'
})
export class OverlayIconSample {

    // Make the enum available in the template
    readonly OverlayIcons = OverlayIcons;
}
